import * as React from "react";
import ProductReviewItem, {
    ProductReviewItemProps
} from "~/components/product-review-slider/product-review-item/product-review-item";
import SliderSwiper from "~/components/swiper/slider-swiper";
import { breakpoints } from "~/utils/breakpoint-utils";
import { Settings } from "react-slick";
import ContentSection from "../content-section/content-section";

export interface ProductReviewSliderProps {
    headline: string;
    showMore: string;
    showLess: string;
    productReviews: ProductReviewItemProps["item"][];
}

const ProductReviewSlider: React.FC<ProductReviewSliderProps> = ({
    productReviews,
    showMore,
    showLess,
    headline
}) => {
    const baseClass = "product-review-slider";
    const swiperSettings: Settings = {
        slidesToShow: 3,
        swipeToSlide: true,
        lazyLoad: "ondemand",
        initialSlide: 0,
        responsive: [
            {
                breakpoint: breakpoints.cat,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: breakpoints.wolf,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    };

    const labels = {
        showMore,
        showLess
    };

    return (
        <ContentSection className={baseClass}>
            <h2 className="text-align-center h1-style">{headline}</h2>
            <div className={`${baseClass}__inner`}>
                {productReviews.length > 0 && (
                    <SliderSwiper settings={swiperSettings} className="slider-swiper--hasPaddingBottom">
                        {productReviews.map((item, index) => (
                            <ProductReviewItem key={index} item={item} labels={labels} />
                        ))}
                    </SliderSwiper>
                )}
            </div>
        </ContentSection>
    );
};

export default ProductReviewSlider;
